(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7536],{

/***/ 53685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useStatistics; }
});

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./shared/models/endpoits/statistics.endpoint.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StatisticsStatic;

(function (StatisticsStatic) {
  StatisticsStatic["statistics"] = "/v2/statistics";
})(StatisticsStatic || (StatisticsStatic = {}));

var StatisticsDynamic = {// /**
  //  * @member {string}
  //  * @method GET
  //  * @version 2.0
  //  * @description get Statistics details
  //  */
  // StatisticsDetail: (StatisticsID?: number) =>
  //   `-${StatisticsID}`,
};
var StatisticsEndpoints = _objectSpread(_objectSpread({}, StatisticsDynamic), StatisticsStatic);
// EXTERNAL MODULE: ./api/base-services.request.ts + 1 modules
var base_services_request = __webpack_require__(11882);
;// CONCATENATED MODULE: ./api/statistics-services.request.ts


var getStatistics = function getStatistics(filters) {
  return (0,base_services_request/* getRequest */.A_)(StatisticsEndpoints.statistics, filters).then(function (response) {
    return response === null || response === void 0 ? void 0 : response.data;
  });
};
;// CONCATENATED MODULE: ./custom-hooks/use-statistics.hook.ts


function useStatistics(filters) {
  return (0,useQuery/* useQuery */.a)(["statistics", filters], function () {
    return getStatistics(filters);
  }, {
    cacheTime: 5 * 60 * 1000,
    // 5 minutos
    staleTime: 2 * 60 * 1000 // 2 minutos

  });
}

/***/ }),

/***/ 78430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ franquicias; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./shared/components/Button/index.tsx
var Button = __webpack_require__(66621);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components-pages/franquicias/RemaxFranchise.tsx



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






function RemaxFranchise() {
  var jumpToFranchise = function jumpToFranchise(event) {
    var _event$target;

    var anchor = (((_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.ownerDocument) || document).querySelector("#franchise-content");

    if (anchor) {
      anchor.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  };

  var translation = (0,next_intl_cjs_production_min.useTranslations)("franchise");
  var translationRemaxFranchise = (0,next_intl_cjs_production_min.useTranslations)("franchise.remaxFranchise");

  var _translation$split = translation("title").split(" "),
      _translation$split2 = (0,slicedToArray/* default */.Z)(_translation$split, 2),
      franchise = _translation$split2[0],
      franchiseTwo = _translation$split2[1];

  return (0,emotion_react_browser_esm/* jsx */.tZ)(Wrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(BackgroundImage, null), (0,emotion_react_browser_esm/* jsx */.tZ)(CoverDetails, null, (0,emotion_react_browser_esm/* jsx */.tZ)(CoverContainer, {
    className: "container"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(CoverContent, null, (0,emotion_react_browser_esm/* jsx */.tZ)("h1", null, (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, franchise), " ", franchiseTwo), (0,emotion_react_browser_esm/* jsx */.tZ)("p", null, translationRemaxFranchise("description")), (0,emotion_react_browser_esm/* jsx */.tZ)("p", null, translationRemaxFranchise("info")), (0,emotion_react_browser_esm/* jsx */.tZ)(CoverButton, {
    onClick: jumpToFranchise,
    component: "a"
  }, translationRemaxFranchise("getFranchise").toUpperCase())))));
}

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e1fkcfg35"
} : 0)( true ? {
  name: "n4gspc",
  styles: "width:100%;position:relative;margin-bottom:-200px;@media screen and (max-width: 991px){margin-bottom:0;}"
} : 0);

var BackgroundImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1fkcfg34"
} : 0)( true ? {
  name: "1hxhrr4",
  styles: "width:100%;height:130dvh;background-position:center right;transform:scaleX(-1);margin-top:70px;background-size:cover;background-repeat:no-repeat;background-image:url(\"/images/v2/pic/image-03.webp\");@media screen and (max-width: 991px){height:60vw;}"
} : 0);

var CoverDetails = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1fkcfg33"
} : 0)( true ? {
  name: "j29clm",
  styles: "width:100%;height:100%;position:absolute;top:0;@media screen and (max-width: 991px){position:static;height:auto;background-color:var(--color-brand-blue-main);}"
} : 0);

var CoverContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1fkcfg32"
} : 0)( true ? {
  name: "zkc6ye",
  styles: "height:100%;position:relative;@media screen and (max-width: 1300px){position:static;}"
} : 0);

var CoverContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1fkcfg31"
} : 0)( true ? {
  name: "zr562x",
  styles: "position:absolute;right:0;top:190px;width:563px;padding:40px 57px 100px;background-color:var(--color-brand-blue-main);border-radius:15px;&>h1{font-size:1.938rem;font-weight:700;color:var(--color-text-white);margin-bottom:33px;&>span{}}&>p{color:var(--color-text-white);font-size:15.6px;font-weight:400;margin-bottom:20px;line-height:18px;}@media screen and (max-width: 991px){text-align:center;}@media screen and (max-width: 1300px){right:20px;}@media screen and (max-width: 991px){position:static;width:100%;}@media screen and (max-width: 767px){padding-left:10px;padding-right:10px;}"
} : 0);

var CoverButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Button/* default */.Z,  true ? {
  target: "e1fkcfg30"
} : 0)( true ? {
  name: "7q2i2q",
  styles: "position:absolute;bottom:-20px;margin:0 auto;max-width:265px;left:50%;transform:translateX(-50%);z-index:10;width:100%;border-radius:15px!important;font-size:15px"
} : 0);

/* harmony default export */ var franquicias_RemaxFranchise = (RemaxFranchise);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(36864);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./shared/components/benefits-card/index.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function benefits_card_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




function BenefitsCard(props) {
  var _imgProps, _imgProps2;

  var title = props.title,
      img = props.img,
      text = props.text,
      as = props.as;
  var imgProps;
  var Text;

  if (typeof img === "object") {
    imgProps = _objectSpread({}, img);
  } else {
    imgProps = {
      src: img
    };
  }

  if (Array.isArray(text)) {
    Text = text.map(function (e, index) {
      return (0,emotion_react_browser_esm/* jsx */.tZ)(CardText, {
        key: index
      }, e);
    });
  } else {
    Text = (0,emotion_react_browser_esm/* jsx */.tZ)(CardText, null, text);
  }

  return (0,emotion_react_browser_esm/* jsx */.tZ)(benefits_card_Wrapper, {
    as: as
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(CardHeader, null, (0,emotion_react_browser_esm/* jsx */.tZ)(CardLogo, null, (_imgProps = imgProps) !== null && _imgProps !== void 0 && _imgProps.src ? (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    role: "img",
    "aria-label": ((_imgProps2 = imgProps) === null || _imgProps2 === void 0 ? void 0 : _imgProps2.alt) || title,
    style: {
      display: "block",
      width: "100%",
      height: "100%",
      backgroundColor: "#000e35",
      WebkitMaskImage: "url(".concat(imgProps.src, ")"),
      maskImage: "url(".concat(imgProps.src, ")"),
      WebkitMaskRepeat: "no-repeat",
      maskRepeat: "no-repeat",
      WebkitMaskPosition: "center",
      maskPosition: "center",
      WebkitMaskSize: "contain",
      maskSize: "contain"
    }
  }) : (0,emotion_react_browser_esm/* jsx */.tZ)("img", imgProps)), (0,emotion_react_browser_esm/* jsx */.tZ)(CardTitle, null, title)), (0,emotion_react_browser_esm/* jsx */.tZ)(CardBody, null, Text));
}

var benefits_card_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eysvgk75"
} : 0)( true ? {
  name: "xi393n",
  styles: "display:flex;width:100%;flex-direction:column;row-gap:1rem;min-height:250px;max-width:350px;@media (max-width: 768px){min-height:150px;margin:1rem 0;}"
} : 0);

var CardHeader = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eysvgk74"
} : 0)( true ? {
  name: "8fwi0w",
  styles: "width:100%;display:flex;flex-direction:column;row-gap:1rem;@media (max-width: 768px){align-items:center;}"
} : 0);

var CardTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "eysvgk73"
} : 0)( true ? {
  name: "10ubycv",
  styles: "font-size:1.3rem;font-weight:700;color:var(--color-text-primary);line-height:1;width:100%;text-align:left;display:flex;justify-content:flex-start;text-transform:none;white-space:nowrap;margin:0;@media (max-width: 768px){text-align:center;justify-content:center;}"
} : 0);

var CardLogo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eysvgk72"
} : 0)( true ? {
  name: "6awaea",
  styles: "width:70px;height:70px;img{width:100%;height:100%;object-fit:contain;display:none;}"
} : 0);

var CardBody = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eysvgk71"
} : 0)( true ? {
  name: "1i6peh",
  styles: "width:100%;align-self:stretch;padding-right:1.5rem;@media (max-width: 768px){padding:0 2.3rem;text-align:left;}@media (max-width: 568px){padding:0 1rem;text-align:left;}"
} : 0);

var CardText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "eysvgk70"
} : 0)( true ? {
  name: "10gfbpq",
  styles: "font-size:0.938rem;color:#616161;font-weight:400;line-height:18px;margin-bottom:15px;width:100%"
} : 0);

/* harmony default export */ var benefits_card = (BenefitsCard);
;// CONCATENATED MODULE: ./shared/components-pages/franquicias/Benefits.tsx



function Benefits_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






function Benefits() {
  var translation = (0,next_intl_cjs_production_min.useTranslations)("franchise.benefits");
  var benefitsArray = [{
    title: translation("risk"),
    img: {
      src: "/icons/remaxrd_inversion_icon.svg",
      alt: "Icono Inversiones"
    },
    text: translation("riskInfo")
  }, {
    title: translation("promotion"),
    img: {
      src: "/icons/remaxrd_promocion_icon.svg",
      alt: "Icono Promociones"
    },
    text: translation("promotionInfo")
  }, {
    title: translation("training"),
    img: {
      src: "/icons/remaxrd_capacitacion_icon.svg",
      alt: "Icono Capacitación"
    },
    text: translation("trainingInfo")
  }, {
    title: translation("technology"),
    img: {
      src: "/icons/remaxrd_recursos_icon.svg",
      alt: "Icono Recursos"
    },
    text: [translation("technologyInfo"), translation("technologyInfoTwo")]
  }, {
    title: translation("network"),
    img: {
      src: "/icons/remaxrd_red_icon.svg",
      alt: "Icono Red"
    },
    text: translation("networkInfo")
  }, {
    title: translation("support"),
    img: {
      src: "/icons/remaxrd_asistencia_icon.svg",
      alt: "Icono Asistencia"
    },
    text: translation("supportInfo")
  }];
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Benefits_Wrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, (0,emotion_react_browser_esm/* jsx */.tZ)(SectionTitle, null, translation("title"))), (0,emotion_react_browser_esm/* jsx */.tZ)(BenefitsContainer, {
    className: "container"
  }, benefitsArray.map(function (benefit, index) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(benefits_card, (0,esm_extends/* default */.Z)({}, benefit, {
      as: "article",
      key: index
    }));
  })));
}

var Benefits_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e1jsy74w2"
} : 0)( true ? {
  name: "188l6dy",
  styles: "background-color:var(--color-brand-cream-primary);border-radius:200px 200px 0px 0px;padding:100px 0 50px;position:relative;z-index:20;svg,svg *{color:#000e35!important;fill:#000e35!important;stroke:#000e35!important;}@media screen and (max-width: 991px){border-radius:0px;z-index:0;}"
} : 0);

var SectionTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e1jsy74w1"
} : 0)( true ? {
  name: "j9i5k5",
  styles: "font-size:1.438rem;font-weight:700;text-align:center;margin:0 0 20px;color:var(--color-text-primary);margin-bottom:3rem;padding:0 0.8rem"
} : 0);

var BenefitsContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1jsy74w0"
} : 0)( true ? {
  name: "13biy20",
  styles: "display:grid;grid-template:auto/auto auto auto;gap:20px;place-content:center;background-color:white;border-radius:12px;padding:2.5rem;@media screen and (max-width: 991px){grid-template:auto/auto auto;padding:0rem;}@media screen and (max-width: 767px){grid-template:auto/auto;border-radius:0px;}"
} : 0);

/* harmony default export */ var franquicias_Benefits = (Benefits);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toArray.js
var toArray = __webpack_require__(83618);
// EXTERNAL MODULE: ./custom-hooks/use-statistics.hook.ts + 2 modules
var use_statistics_hook = __webpack_require__(53685);
;// CONCATENATED MODULE: ./shared/components-pages/franquicias/OurLocation.tsx



function OurLocation_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






function OurLocation() {
  var _statistics$data, _statistics$data2;

  var translation = (0,next_intl_cjs_production_min.useTranslations)("franchise.locations");
  var title = translation("title") || "";

  var _title$split = title.split(" "),
      _title$split2 = (0,toArray/* default */.Z)(_title$split),
      first = _title$split2[0],
      rest = _title$split2.slice(1);

  var _useStatistics = (0,use_statistics_hook/* default */.Z)(),
      statistics = _useStatistics.data;

  var year = new Date().getFullYear();
  return (0,emotion_react_browser_esm/* jsx */.tZ)(OurLocation_Wrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(LocationDetails, null, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "container"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(LocationTitle, null, first, " ", (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, rest)), (0,emotion_react_browser_esm/* jsx */.tZ)(LocationImages, null, (0,emotion_react_browser_esm/* jsx */.tZ)(StaticImage, null, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "circle-container"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "year circle"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "circle-year"
  }, year)), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "locations circle"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "circle-text"
  }, "Asociados"), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "circle-number"
  }, (statistics === null || statistics === void 0 ? void 0 : (_statistics$data = statistics.data) === null || _statistics$data === void 0 ? void 0 : _statistics$data.agents_count) || 0)), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "agents circle"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "circle-text"
  }, "Franquicias"), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "circle-number"
  }, (statistics === null || statistics === void 0 ? void 0 : (_statistics$data2 = statistics.data) === null || _statistics$data2 === void 0 ? void 0 : _statistics$data2.agencies_count) || 0))), (0,emotion_react_browser_esm/* jsx */.tZ)(Images, {
    src: "/images/v2/pic/image-06.png",
    alt: "Ubicaci\xF3n oficinas de remax republica dominicana"
  }))))), (0,emotion_react_browser_esm/* jsx */.tZ)(OurLocation_BackgroundImage, null));
}

var StaticImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xuix4v7"
} : 0)( true ? {
  name: "tibobf",
  styles: "position:relative;.circle-container{transform:translate(85%, 80px);}.circle{position:absolute;top:0;left:0;width:100px;height:100px;border-radius:50%;line-height:1;font-size:1.5rem;font-weight:700;color:white;text-align:center;flex-direction:column;display:flex;align-items:center;justify-content:center;.circle-year{font-size:1rem;font-weight:800;color:var(--color-brand-blue-secondary);}.circle-text{font-size:0.7rem;font-weight:400;color:white;}.circle-number{font-size:1.5rem;font-weight:700;color:white;}}.year{top:0;left:0;z-index:1;border:6px solid var(--color-brand-blue-secondary);display:flex;flex-direction:column;align-items:center;justify-content:flex-start;color:var(--color-brand-blue-secondary);font-size:1rem;font-weight:700;padding-top:10px;}.locations{position:absolute;top:40px;left:30px;background-color:var(--color-brand-red-main);z-index:2;.circle-number{font-size:2.3rem;font-weight:700;color:white;line-height:0.9;}}.agents{position:absolute;top:20px;left:-60px;background-color:var(--color-brand-blue-main);z-index:3;.circle-number{font-size:1.5rem;font-weight:700;color:white;line-height:1;}}@media (max-width: 800px){.circle-container{transform:translate(80%, 30px);}}@media (max-width: 508px){.circle-container{transform:translate(80%, 10px);}.circle{width:50px;height:50px;font-size:0.8rem;.circle-text{font-size:0.3rem;}.circle-number{font-size:0.8rem;}}.year{font-size:0.7rem;padding-top:5px;border-width:3px;.circle-year{font-size:0.7rem;}}.locations{top:30px;left:10px;}.agents{top:18px;left:-30px;}}"
} : 0);

var OurLocation_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e1xuix4v6"
} : 0)( true ? {
  name: "1a3qx8l",
  styles: "background-color:var(--color-brand-cream-primary);padding:80px 0 0;margin-bottom:-210px;max-width:100dvw;overflow:hidden"
} : 0);

var LocationDetails = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xuix4v5"
} : 0)( true ? "" : 0);

var OurLocation_BackgroundImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xuix4v4"
} : 0)( true ? {
  name: "1aqhzvz",
  styles: "width:100%;height:400px;background-position:bottom left;background-size:cover;background-repeat:no-repeat;background-image:url(\"/images/image-optimize/remax_rd_Asset34.webp\")"
} : 0);

var LocationTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e1xuix4v3"
} : 0)( true ? {
  name: "1inw6vl",
  styles: "font-size:1.438rem;font-weight:700;text-align:center;margin-bottom:0;color:var(--color-text-primary);&>span{font-weight:300;color:var(--color-text-primary);}"
} : 0);

var LocationImages = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xuix4v2"
} : 0)( true ? {
  name: "18dcmi1",
  styles: "width:100%;max-width:1000px;margin:0 auto;position:relative;margin-top:20px"
} : 0);

var Images = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "e1xuix4v1"
} : 0)( true ? {
  name: "16d60fp",
  styles: "width:100%;border-style:none"
} : 0);

var ImagesAbsolute = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "e1xuix4v0"
} : 0)( true ? {
  name: "7ndeqr",
  styles: "position:absolute;right:10%;top:15%;width:20%"
} : 0);

/* harmony default export */ var franquicias_OurLocation = (OurLocation);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./shared/components/text-field/index.tsx + 2 modules
var text_field = __webpack_require__(22900);
// EXTERNAL MODULE: ./api/messages.request.ts + 1 modules
var messages_request = __webpack_require__(27929);
// EXTERNAL MODULE: ./shared/components/form-with-host-post/index.tsx
var form_with_host_post = __webpack_require__(36671);
// EXTERNAL MODULE: ./shared/models/const/form-hotpots.ts
var form_hotpots = __webpack_require__(63416);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
;// CONCATENATED MODULE: ./shared/components-pages/franquicias/ObtainYourFranchise.tsx





function ObtainYourFranchise_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








 // import { useModal } from "shared/context/ModalAlert.context";





var postData = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
    var response;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0,messages_request/* postFranchiseMessage */.V2)(data);

          case 2:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function postData(_x) {
    return _ref.apply(this, arguments);
  };
}();

function ObtainYourFranchise() {
  // const modal = useModal();
  var _useState = (0,react.useState)(Math.random()),
      key = _useState[0],
      setKey = _useState[1];

  var _useState2 = (0,react.useState)(false),
      openModal = _useState2[0],
      setOpenModal = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isSubscribed = _useState3[0],
      setIsSubscribed = _useState3[1];

  var translation = (0,next_intl_cjs_production_min.useTranslations)("franchise.form");
  var translationAlert = (0,next_intl_cjs_production_min.useTranslations)("alerts.franchise");
  var translationError = (0,next_intl_cjs_production_min.useTranslations)("error");
  var validationSchema = es/* object */.Ry({
    full_name: es/* string */.Z_().required(translationError("required")),
    phone: es/* string */.Z_().required(translationError("required")).length(10, translationError("phone")),
    email: es/* string */.Z_().email(translationError("email")).required(translationError("required")),
    address: es/* string */.Z_().required(translationError("required")),
    birthdate: es/* date */.hT().required(translationError("required")).nullable(),
    // captcha: yup.string().required(translationError("required")),
    subscribe: es/* boolean */.O7().required(translationError("required"))
  });

  var onSubmit = function onSubmit(values, e) {
    var data = {
      address: values.address,
      email: values.email,
      full_name: values.full_name,
      phone: values.phone,
      birthdate: values.birthdate,
      "g-recaptcha-response": values.captcha,
      subscribe: values.subscribe
    };
    setIsSubscribed(values.subscribe);
    mutate(data, {
      onSuccess: function onSuccess() {
        e.resetForm();
        e.setFieldValue("birthdate", null);
      }
    });
  };

  var _useMutation = (0,useMutation/* useMutation */.D)(postData, {
    onSuccess: function onSuccess() {
      return handleModal();
    }
  }),
      mutate = _useMutation.mutate,
      isLoading = _useMutation.isLoading,
      isError = _useMutation.isError;

  var handleModal = function handleModal() {
    setOpenModal(!openModal);
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(ObtainYourFranchise_Wrapper, {
    id: "franchise-content"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "container",
    id: "franchise"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Title, null, translation("title")), (0,emotion_react_browser_esm/* jsx */.tZ)(FranchiseForm, null, (0,emotion_react_browser_esm/* jsx */.tZ)(form_with_host_post/* default */.Z, (0,esm_extends/* default */.Z)({
    key: key
  }, form_hotpots/* default.FRANQUICIAS */.Z.FRANQUICIAS, {
    onFormSubmitError: function onFormSubmitError() {// modal.openModal({
      //   title: translationAlert("title"),
      //   body: translationAlert("body"),
      //   variant: "error",
      //   handleClose: () => {},
      // });
      // setKey(Math.random());
    },
    onFormSubmitSuccess: function onFormSubmitSuccess() {// modal.openModal({
      //   title: translationAlert("title"),
      //   body: translationAlert("body"),
      //   variant: "success",
      //   handleClose: () => {
      //     setOpenModal(false);
      //   },
      // });
      // setKey(Math.random());
    }
  })))));
} //  <Formik
//    initialValues={initialValues}
//    onSubmit={onSubmit}
//    validationSchema={validationSchema}
//  >
//    {(formikProps) => {
//      return (
//        <FranchiseForm>
//          <InputWrapper>
//            <Input
//              name="full_name"
//              placeholder={translation("fullName") + "*"}
//            />
//          </InputWrapper>
//          <InputWrapper>
//            <Input
//              name="phone"
//              placeholder={translation("phone") + "*"}
//              inputComponent={PhoneMask}
//            />
//          </InputWrapper>
//          <InputWrapper>
//            <Input name="email" placeholder={translation("email") + "*"} />
//          </InputWrapper>
//          <InputWrapper>
//            <Input name="address" placeholder={translation("address") + "*"} />
//          </InputWrapper>
//          <InputWrapper>
//            <DateTimePickerField
//              placeholder={translation("birthDate") + "*"}
//              type="no-custom"
//              name="birthdate"
//            />
//          </InputWrapper>
//          <InputWrapper className="subscriber">
//            <CheckboxCustom
//              onChange={() => {
//                formikProps.setFieldValue(
//                  "subscribe",
//                  !formikProps.values.subscribe
//                );
//              }}
//              checked={formikProps.values.subscribe}
//              name="subscribe"
//              style={{
//                display: "inline-block",
//                justifyContent: "flex-start",
//                padding: "5px 0px 9px 9px",
//              }}
//            />
//            <LabelField
//              label={translation("subscribe")}
//              positionLabel="left"
//            />
//          </InputWrapper>
//          {/* <RecaptchaField formikProps={formikProps} /> */}
//          <SubmitWrapper>
//            <SubmitButton
//              type="submit"
//              disabled={isLoading}
//              loadingMessage={isLoading ? translation("sending") : null}
//              className="enviar-formulario-adquire-franquicia"
//            >
//              {translation("send")}
//            </SubmitButton>
//          </SubmitWrapper>
//        </FranchiseForm>
//      );
//    }}
//  </Formik>;


var ObtainYourFranchise_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e1bsvaxk6"
} : 0)( true ? {
  name: "12t5qbg",
  styles: "background-color:#f0f0f0;border-radius:200px 200px 0px 0px;padding:93px 0 110px;@media screen and (max-width: 991px){border-radius:150px 150px 0px 0px;}@media screen and (max-width: 767px){border-radius:0;}@media screen and (max-width: 487px){padding:63px 0 110px;}"
} : 0);

var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e1bsvaxk5"
} : 0)( true ? {
  name: "1qdb9su",
  styles: "font-size:1.75rem;font-weight:500;margin-bottom:60px;text-transform:none;color:var(--color-text-primary)"
} : 0);

var FranchiseForm = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Box/* default */.Z,  true ? {
  target: "e1bsvaxk4"
} : 0)( true ? {
  name: "lr8y9q",
  styles: "display:flex;flex-wrap:wrap;justify-content:space-between;max-width:750px;margin:0 auto;@media screen and (max-width: 767px){padding:1rem;}"
} : 0);

var SubmitButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Button/* default */.Z,  true ? {
  target: "e1bsvaxk3"
} : 0)( true ? {
  name: "1okvbwy",
  styles: "margin:45px auto 0;width:172px"
} : 0);

var Input = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(text_field/* default */.Z,  true ? {
  target: "e1bsvaxk2"
} : 0)( true ? {
  name: "18lnv40",
  styles: "color:var(--color-brand-blue-main);font-size:1.1rem;font-weight:700;border:none;outline:none;background-color:var(--color-brand-bg-secondary);margin-bottom:5px;&::placeholder{font-size:inherit;font-weight:inherit;color:inherit;}&:hover{border:none;}"
} : 0);

var InputWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1bsvaxk1"
} : 0)( true ? {
  name: "11te235",
  styles: "width:48%;margin-bottom:20px;&.subscriber{width:100%;display:flex;align-items:center;}@media screen and (max-width: 767px){width:100%;}"
} : 0);

var SubmitWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1bsvaxk0"
} : 0)( true ? {
  name: "r3fe4a",
  styles: "flex-basis:100%;display:flex"
} : 0);

var initialValues = {
  full_name: "",
  email: "",
  phone: "",
  address: "",
  birthdate: "",
  captcha: "",
  subscribe: true
};
/* harmony default export */ var franquicias_ObtainYourFranchise = (ObtainYourFranchise);
// EXTERNAL MODULE: ./shared/models/functions/removeparams.ts
var removeparams = __webpack_require__(57626);
;// CONCATENATED MODULE: ./pages/franquicias/index.tsx











var Franquicias = function Franquicias(props) {
  var router = (0,next_router.useRouter)();
  var titleT = (0,next_intl_cjs_production_min.useTranslations)("title-pages");
  (0,react.useEffect)(function () {
    var hash = props.hash;

    if (hash) {
      var anchor = document.querySelector("#" + hash);

      if (anchor) {
        anchor.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      }
    }
  }, [props.hash]);
  var metaData = {
    description: "Remax es la red inmobiliaria #1 a nivel mundial, con más de 138 mil agentes, distribuidos en 110 países.",
    keyWords: "Franquicia Remax, franquicia inmobiliaria, adquirir franquicia inmobiliaria, Franquicias inmobiliarias Remax República Dominicana, adquirir franquicia en remax rd",
    title: titleT("franchise"),
    url: "https://unete.remaxrd.com" + router.asPath,
    image: "https://unete.remaxrd.com" + "/images/image-optimize/two-smiling-clerk-businessmen-deliberate-on-problem_1.webp"
  };
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)((head_default()), null, (0,emotion_react_browser_esm/* jsx */.tZ)("title", null, metaData.title), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    name: "description",
    content: metaData.description
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    name: "keywords",
    content: metaData.keyWords
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    property: "og:url",
    content: metaData.url
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    property: "og:title",
    content: metaData.title
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    property: "og:image",
    content: metaData.image
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("link", {
    rel: "canonical",
    href: (0,removeparams/* default */.Z)("https://unete.remaxrd.com" + router.asPath),
    key: "canonical"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(franquicias_RemaxFranchise, null), (0,emotion_react_browser_esm/* jsx */.tZ)(franquicias_Benefits, null), (0,emotion_react_browser_esm/* jsx */.tZ)(franquicias_OurLocation, null), (0,emotion_react_browser_esm/* jsx */.tZ)(franquicias_ObtainYourFranchise, null));
};

var __N_SSP = true;
/* harmony default export */ var franquicias = (Franquicias);

/***/ }),

/***/ 36671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86886);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70917);




function FormWithHostPost(props) {
  var targetId = props.targetId,
      formId = props.formId,
      onFormSubmitError = props.onFormSubmitError,
      onFormSubmitSuccess = props.onFormSubmitSuccess;
  var hasFormRenderedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  var config = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return {
      region: "na1",
      portalId: "24346264",
      formId: formId,
      target: "#".concat(targetId),
      onFormSubmit: function onFormSubmit(_form) {// if (onFormSubmitSuccess) {
        //   setTimeout(() => {
        //     onFormSubmitSuccess();
        //   }, 1000);
        // }
      },
      onFormError: function onFormError(_errors) {
        if (onFormSubmitError) {
          onFormSubmitError();
        }
      },
      onFormSubmitted: function onFormSubmitted(_form) {
        if (onFormSubmitSuccess) {
          onFormSubmitSuccess();
        }
      }
    };
  }, [formId, targetId, onFormSubmitError, onFormSubmitSuccess]);
  var resetTarget = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    var targetElement = document.getElementById(targetId);

    if (targetElement) {
      targetElement.innerHTML = "";
    }
  }, [targetId]);
  var createForm = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    var _window$hbspt;

    if (false) {}

    if (hasFormRenderedRef.current) {
      return;
    }

    var targetElement = document.getElementById(targetId); // Ensure the container exists before we try to clear or render the form.

    if (!targetElement) {
      return;
    }

    resetTarget(); // @ts-ignore

    var hbsptForms = (_window$hbspt = window.hbspt) === null || _window$hbspt === void 0 ? void 0 : _window$hbspt.forms;

    if (hbsptForms) {
      hbsptForms.create(config);
      hasFormRenderedRef.current = true;
    }
  }, [config, resetTarget, targetId]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (false) {}

    hasFormRenderedRef.current = false;
    var scriptSrc = "https://js.hsforms.net/forms/embed/v2.js";
    var scriptId = "hs-form-script-".concat(formId);

    var handleScriptLoad = function handleScriptLoad() {
      createForm();
    };

    var markLoadedAndCreate = function markLoadedAndCreate() {
      var scriptElement = document.getElementById(scriptId);

      if (scriptElement) {
        scriptElement.setAttribute("data-loaded", "true");
      }

      handleScriptLoad();
    };

    var existingScript = document.getElementById(scriptId);

    if (existingScript) {
      if (existingScript.getAttribute("data-loaded") === "true") {
        createForm();
      } else {
        existingScript.addEventListener("load", markLoadedAndCreate);
      }
    } else {
      var script = document.createElement("script");
      script.id = scriptId;
      script.src = scriptSrc;
      script.async = true;
      script.addEventListener("load", markLoadedAndCreate);
      document.body.appendChild(script);
    }

    return function () {
      var script = document.getElementById(scriptId);

      if (script) {
        script.removeEventListener("load", markLoadedAndCreate);
      }

      resetTarget();
      hasFormRenderedRef.current = false;
    };
  }, [createForm, formId, resetTarget]);
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
    container: true,
    item: true,
    xs: 12
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
    item: true,
    xs: 12,
    id: props.targetId
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (FormWithHostPost); // FormWithHostPost;

/***/ }),

/***/ 63416:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var FormHotpots = {
  FRANQUICIAS: {
    formId: "9b2acf82-c910-45e4-acde-a215af7498b0",
    targetId: "FRANQUICIAS-FORM"
  },
  UNETE: {
    formId: "bf07a8e7-9992-4fad-958c-291d86b8736a",
    targetId: "JOIN-FORM"
  },
  MORTGAGE_REFERRAL_BPD: {
    formId: "4c16367a-690e-4d10-90a7-ec2dd74d43e5",
    targetId: "MORTGAGE-REFERRAL-BPD-FORM"
  },
  SUSCRIBE_BLOG_FOOTER: {
    formId: "2e0183da-89fb-4de1-bcfb-244a7167438f",
    targetId: "SUSCRIBE_BLOG_FOOTER"
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (FormHotpots);

/***/ }),

/***/ 76873:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/franquicias",
      function () {
        return __webpack_require__(78430);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36492:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useQuery; }
/* harmony export */ });
/* harmony import */ var _tanstack_query_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32161);
/* harmony import */ var _tanstack_query_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52924);
/* harmony import */ var _useBaseQuery_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67187);
'use client';



function useQuery(arg1, arg2, arg3) {
  const parsedOptions = (0,_tanstack_query_core__WEBPACK_IMPORTED_MODULE_0__/* .parseQueryArgs */ ._v)(arg1, arg2, arg3);
  return (0,_useBaseQuery_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useBaseQuery */ .r)(parsedOptions, _tanstack_query_core__WEBPACK_IMPORTED_MODULE_2__/* .QueryObserver */ .z);
}


//# sourceMappingURL=useQuery.mjs.map


/***/ }),

/***/ 83618:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _toArray; }
/* harmony export */ });
/* harmony import */ var _arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14666);
/* harmony import */ var _iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28811);
/* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2937);
/* harmony import */ var _nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14882);




function _toArray(arr) {
  return (0,_arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr) || (0,_unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr) || (0,_nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3828,9774,2888,179], function() { return __webpack_exec__(76873); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);